import axios from "axios";
import { Message, MessageBox } from "element-ui";
import store from "../store";
import { getToken, getAgentUserId, getAgentId } from "@/utils/auth";
import { BASE_URI } from "@/config";
import router from "@/router";

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 60000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  config => {
    if (
      store.getters.token &&
      !config.url.startsWith(BASE_URI + "/oauth/login")
    ) {
      config.headers["Authorization"] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers["Authorizator"] = getAgentUserId(); // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers["Organization"] = getAgentId(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    return config;
  },
  error => {
    // Do something with request error
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    // if (response.config.url.startsWith(BASE_URI + "/oauth/")) {
    //   return res;
    // }
    if (res.type === "application/octet-stream") {
      return response;
    }
    if (res.code !== 200 && typeof res.code !== 'undefined') {
      Message({
        message: res.message,
        type: "error",
        duration: 5 * 1000
      });
      return response.data;
    } else {
      return response.data;
    }
  },
  error => {
    var message = "服务器请求失败";
    if (error.response && error.response.data) {
      if (error.response.data.message) {
        message = error.response.data.message;
      }
    } else if (
      error.response &&
      error.response.status === 401 &&
      !error.response.config.url.startsWith(BASE_URI + "/oauth")
    ) {
      if (!error.response.config.silent401) {
        MessageBox.confirm("登录已过期，请重新登录", "登录过期", {
          confirmButtonText: "确定",
          showCancelButton: false,
          closeOnClickModal: false,
          showClose: false,
          type: "warning"
        }).then(() => {
          store.dispatch("clearAccessInfo").then(() => {
            store.dispatch("clearRoutes").then(() => {
              if (localStorage.getItem('loginRoute')) {
                try {
                  let route = JSON.parse(localStorage.getItem('loginRoute'))
                  router.push(route)
                } catch (e) {
                  router.push('/login')
                }
              } else {
                router.push('/login')
              }
            });
          });
        });
      } else {
        store.dispatch("clearAccessInfo").then(() => {
          store.dispatch("clearRoutes").then(() => {
            if (localStorage.getItem('loginRoute')) {
              try {
                let route = JSON.parse(localStorage.getItem('loginRoute'))
                router.push(route)
              } catch (e) {
                router.push('/login')
              }
            } else {
              router.push('/login')
            }
          });
        });
      }
    }
    if (
      !error.response ||
      !(
        error.response.status === 401 &&
        !error.response.config.url.startsWith(BASE_URI + "/oauth")
      )
    ) {
      Message({
        message: message,
        type: "error",
        duration: 5 * 1000
      });
    }
    return Promise.reject(error);
  }
);

export default service;
